import React from 'react';
export const Label = ({
  className = '',
  children,
  ...props
}) => {
  return <label className={`block text-sm font-medium text-gray-700 ${className}`} {...props} data-id="element-679">
      {children}
    </label>;
};